module.exports = __webpack_public_path__ + "img/case-hotel.3ecab71c.png";